import { useEffect } from 'react'

const useWindowMessage = callback => {
  useEffect(() => {
    window.addEventListener('message', callback)

    return () => {
      window.removeEventListener('message', callback)
    }
  })
}

export default useWindowMessage
